import { marker } from "@jsverse/transloco-keys-manager/marker";
import dayjs from "dayjs";
import { from, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import {
  loadDemoStorage,
  writeDemoStorage
} from "src/app/support/demo-storage";
import { uuid } from "src/app/support/uuid";
import { UserNotify } from "src/app/support/notify-decorator";
import { rxRandomErrorDelayAsync } from "src/app/support/rx-random-error-delay";
import { Injectable } from "@angular/core";
import { RegistryHeading } from "../models/registry-heading/registry-heading";
import { RegistryHeadingCreate } from "../models/registry-heading/registry-heading.create";
import { RegistryHeadingLoad } from "../models/registry-heading/registry-heading.load";
import { RegistryHeadingUpdate } from "../models/registry-heading/registry-heading.update";
import { dateUtil } from "src/app/support/date-util";

const DB_NAME = "registry-heading";

@Injectable()
export class RegistryHeadingBackend {
  list(): Observable<RegistryHeading[]> {
    return rxRandomErrorDelayAsync(loadDb());
  }

  load(request: RegistryHeadingLoad): Observable<RegistryHeading> {
    return rxRandomErrorDelayAsync(loadDb()).pipe(
      map((list) => list.find((x) => x.uuid === request.uuid)!)
    );
  }

  @UserNotify({
    successMessage: marker("Carta Intestata creata"),
    errorMessage: marker("Impossibile creare la carta intestata")
  })
  create(request: RegistryHeadingCreate): Observable<string> {
    return rxRandomErrorDelayAsync(loadDb()).pipe(
      switchMap((list) => {
        const newUuid = uuid();
        const newRegistryHeading: Partial<RegistryHeading> = {
          uuid: newUuid,
          name: request.name,
          createdAt: dateUtil().toISOString()
        };

        return from(
          writeDemoStorage(DB_NAME, [...list, newRegistryHeading])
        ).pipe(map(() => newUuid));
      })
    );
  }

  @UserNotify({
    successMessage: marker("Anagrafica aggiornato"),
    errorMessage: marker("Impossibile creare l'anagrafica")
  })
  update(request: RegistryHeadingUpdate): Observable<void> {
    return rxRandomErrorDelayAsync(loadDb()).pipe(
      switchMap((list) => {
        return from(
          writeDemoStorage(
            DB_NAME,
            list.map((x) => {
              if (x.uuid === request.uuid) {
                return {
                  ...x,
                  ...request
                };
              }

              return x;
            })
          )
        );
      })
    );
  }
}

async function loadDb(): Promise<RegistryHeading[]> {
  return (await loadDemoStorage<RegistryHeading[]>(DB_NAME)) || [];
}
